import { GlobalTemplate } from "./GlobalTemplate";
import type { GlobalTemplateProps } from "./GlobalTemplate.d";

export { GlobalTemplate };
export type { GlobalTemplateProps };
